import React from "react";
import AutomotiveImg from "../images/e1.png";
import LocomotiveImg from "../images/e2.jpg";
import GrpPanelImg from "../images/e3.jpg";
import PcbImg from "../images/e4.webp";
import { Wrench, HardDrive, CircuitBoard, Train } from "lucide-react";

const modules = [
  {
    title: "Automotive",
    img: AutomotiveImg,
    icon: <Wrench className="w-6 h-6 text-white" />,
    description:
      "Learn basic 2D wiring harness design and electrical layout concepts used in vehicles.",
    color: "bg-blue-700",
  },
  {
    title: "Locomotive",
    img: LocomotiveImg,
    icon: <Train className="w-6 h-6 text-white" />,
    description:
      "Understand 2D schematics and wiring diagrams for railways and metro systems.",
    color: "bg-red-600",
  },
  {
    title: "Control & Protection Panel (GRP)",
    img: GrpPanelImg,
    icon: <HardDrive className="w-6 h-6 text-white" />,
    description:
      "Design safe and standard GRP panels with both 2D and 3D electrical layouts.",
    color: "bg-lime-600",
  },
  {
    title: "PCB Design Basics",
    img: PcbImg,
    icon: <CircuitBoard className="w-6 h-6 text-white" />,
    description:
      "Explore PCB design from circuit diagrams to 2D & 3D layout planning.",
    color: "bg-pink-600",
  },
];

const ECADModules = () => {
  return (
 <div  className="max-w-6xl mx-auto">
    {/* Heading */}
        <h2 className="text-3xl sm:text-4xl font-bold text-sky-800 text-center mb-12">
          Electrical Internship Modules
        </h2>

    <div className="max-w-6xl mx-auto px-4 py-14 grid gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {modules.map((mod, index) => (
        <div
          key={index}
          className="relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-300 group"
        >
          {/* Image */}
          <div className="overflow-hidden rounded-t-xl">
            <img
              src={mod.img}
              alt={mod.title}
              className="w-full h-48 object-cover transform group-hover:scale-105 transition duration-300"
            />
          </div>

          {/* Icon Badge */}
          <div className={`absolute -top-5 left-5 p-3 rounded-full shadow-md ${mod.color}`}>
            {mod.icon}
          </div>

          {/* Content */}
          <div className="p-6">
            <h3 className="text-lg font-bold text-gray-800 mb-2">{mod.title}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{mod.description}</p>
          </div>
        </div>
      ))}
      </div>
    </div>
  );
};

export default ECADModules;
    